module.exports = __webpack_public_path__ + "static/media/blog-banner.23fb3098.jpg";